import React, { Component } from "react";
import fordStyles from "./GlobalNavBar.module.scss";
import lincolnStyles from "./GlobalNavBar-Lincoln.module.scss";
import { AppBar, Grid, Toolbar, withStyles } from "@material-ui/core";
import { Link } from "react-router-dom";
import { withTranslation } from "react-i18next";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import { invalidateSessionAndRedirect } from "../../common/InvalidateSession";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import HasPermissionTo from "../../common/HasPermissionTo";
import LincolnLogo from "../../common/LincolnLogo";
import { IS_FORD_BRAND } from "../../utils/EmpUtil";
import FordLogo from "../../common/FordLogo";
import KeyboardArrowDown from "@material-ui/icons/KeyboardArrowDown";
import KeyboardArrowUp from "@material-ui/icons/KeyboardArrowUp";

const fullHeight = {
  minHeight: "70px",
  height: "100%",
};

const StyledMenu = withStyles({
  paper: {
    border: "1px solid #d3d4d5",
  },
})((props) => (
  <Menu
    elevation={10}
    getContentAnchorEl={null}
    anchorOrigin={{
      vertical: "bottom",
      horizontal: "right",
    }}
    transformOrigin={{
      vertical: "top",
      horizontal: "right",
    }}
    {...props}
  />
));

const StyledMenuItem = withStyles({
  root: {
    paddingLeft: "10px",
    paddingRight: "10px",
    color: "#102b4e",
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
  },
})(MenuItem);

class GlobalNavBar extends Component {
  constructor(props) {
    super(props);

    this.state = {
      anchorEl: null,
      open: false,
    };
  }

  componentDidMount() {
    const headerHeight = document.getElementById("appHeader").clientHeight;
    this.props.setPadding(headerHeight);
  }

  handleLogoutClick = (event) => {
    this.setState({ anchorEl: event.currentTarget });
  };

  handleLogoutClose = () => {
    this.setState({ anchorEl: null });
  };

  handleLogoutDialogOpen = () => {
    this.setState({ open: true });
  };

  handleLogoutDialogClose = () => {
    this.setState({ open: false });
  };

  handleOrderSearch = () => {
    this.props.fromNscDealerSearch
      ? window.location.assign(`/search/orders`)
      : this.props.history.push({
          pathname: `/search/orders`,
        });
    this.setState({
      anchorEl: null,
    });
  };

  handleDealerSearch = () => {
    this.props.fromNscDealerSearch
      ? window.location.assign(`/search/dealer`)
      : this.props.history.push({
          pathname: `/search/dealer`,
        });
    this.setState({
      anchorEl: null,
    });
  };

  handlePoOrderSearch = () => {
    window.location.href = `/search/orders`;
    this.setState({
      anchorEl: null,
    });
  };

  handlePoDealerSearch = () => {
    window.location.href = `/search/dealer`;
    this.setState({
      anchorEl: null,
    });
  };

  handlePoNscSearch = () => {
    window.location.href = `/search/nsc`;
    this.setState({
      anchorEl: null,
    });
  };

  isActive(currentUrl, styles) {
    if (this.props.urlPath === currentUrl) {
      return styles.active;
    } else if (
      (currentUrl === "/dealer/customer-reservations" ||
        currentUrl === "/customer-handling") &&
      (this.props.urlPath.includes("customer-reservations/order-details") ||
        this.props.urlPath.includes("customer-reservations/purchase-details"))
    ) {
      return styles.active;
    } else if (
      this.props.urlPath &&
      this.props.urlPath.startsWith("/pricing") &&
      currentUrl === "/pricing"
    ) {
      return styles.active;
    } else if (
      this.props.urlPath &&
      this.props.urlPath.startsWith("/search") &&
      currentUrl === "/search"
    ) {
      return styles.active;
    }
    return "";
  }

  updateSubNavTabs() {
    if (!this.props.isNsc) {
      const user = this.props.user;
      if (user) {
        user.updateBusinessSettingsTab && user.updateBusinessSettingsTab(0);
        user.updateDashboardTab && user.updateDashboardTab(0);
      }
    }
  }

  render() {
    const styles = IS_FORD_BRAND(this.props.user.brand)
      ? fordStyles
      : lincolnStyles;

    function getLink(url, displayText) {
      return (
        <Link
          className={this.isActive(url, styles)}
          onClick={() => this.updateSubNavTabs()}
          to={{
            pathname: url,
          }}
        >
          {this.props.t(displayText)}
        </Link>
      );
    }

    const { user } = this.props;
    const name = user.name ? " (" + user.name + ")" : "";

    const showPoLogout =
      this.props.user.permissions.rolePermissions.hasOwnProperty(
        "poUserLogout"
      );
    const showNscLogout =
      this.props.user.permissions.rolePermissions.hasOwnProperty(
        "nscUserLogout"
      );

    return (
      <AppBar
        position="fixed"
        classes={{ root: styles.globalNavBar }}
        id="appHeader"
        data-testid="appHeader"
      >
        <Toolbar style={fullHeight} disableGutters>
          <Grid container style={fullHeight}>
            <Grid item md={12} className={styles.gridItem}>
              <div className={styles.languageContainer}>
                {IS_FORD_BRAND(this.props.user.brand) ? (
                  <FordLogo className={styles.brandLogo} />
                ) : (
                  <LincolnLogo className={styles.brandLogo} />
                )}
              </div>
              <div className={styles.navBarWrapper}>
                <HasPermissionTo
                  perform={["dealerSearch"]}
                  permissions={user.permissions.rolePermissions}
                  condition={this.props.fromDealerSearch}
                  render={() => (
                    <>
                      {getLink.call(
                        this,
                        "/dealer-search",
                        "GlobalNavBar.dealerSearch"
                      )}
                    </>
                  )}
                />
                <HasPermissionTo
                  perform={["dealerSearch"]}
                  permissions={user.permissions.rolePermissions}
                  condition={this.props.fromDealerSearch}
                  render={() => (
                    <>
                      {getLink.call(
                        this,
                        "/field-reporting",
                        "GlobalNavBar.reporting"
                      )}
                    </>
                  )}
                />
                <HasPermissionTo
                  perform={["dashBoardPage"]}
                  permissions={user.permissions.rolePermissions}
                  condition={
                    !this.props.fromDealerSearch &&
                    !this.props.isPo &&
                    !this.props.isCrc
                  }
                  render={() => (
                    <>
                      {getLink.call(
                        this,
                        "/dashboard",
                        "GlobalNavBar.dashboard"
                      )}
                    </>
                  )}
                />
                <HasPermissionTo
                  perform={["pricingPage"]}
                  permissions={user.permissions.rolePermissions}
                  condition={!this.props.isPo && !this.props.isCrc}
                  render={() => (
                    <>
                      {getLink.call(this, "/pricing", "GlobalNavBar.pricing")}
                    </>
                  )}
                />
                <HasPermissionTo
                  perform={["accessoriesPage"]}
                  condition={!this.props.fromDealerSearch}
                  permissions={user.permissions.rolePermissions}
                  render={() => (
                    <>
                      {getLink.call(
                        this,
                        "/pricing/accessories",
                        "GlobalNavBar.accessoriesPricing"
                      )}
                    </>
                  )}
                />

                <HasPermissionTo
                  perform={["ordersPage"]}
                  permissions={user.permissions.rolePermissions}
                  condition={
                    !(
                      this.props.isNsc ||
                      this.props.isPo ||
                      this.props.isCrc
                    ) || this.props.fromNscDealerSearch
                  }
                  render={() => (
                    <>
                      {getLink.call(
                        this,
                        "/dealer/customer-reservations",
                        "GlobalNavBar.orders"
                      )}
                    </>
                  )}
                />
                <HasPermissionTo
                  perform={["businessSettingsPage"]}
                  permissions={user.permissions.rolePermissions}
                  condition={!this.props.isPo && !this.props.isCrc}
                  render={() => (
                    <>
                      {getLink.call(
                        this,
                        "/business-settings",
                        "GlobalNavBar.settings"
                      )}
                    </>
                  )}
                />
                <HasPermissionTo
                  perform={["reportingPage"]}
                  permissions={user.permissions.rolePermissions}
                  condition={!this.props.fromNscDealerSearch}
                  render={() => (
                    <>
                      {getLink.call(
                        this,
                        "/reporting",
                        "GlobalNavBar.reporting"
                      )}
                    </>
                  )}
                />
                <HasPermissionTo
                  perform={["poReportingPage"]}
                  permissions={user.permissions.rolePermissions}
                  condition={!this.props.fromNscDealerSearch}
                  render={() => (
                    <>{getLink.call(this, "/", "GlobalNavBar.reporting")}</>
                  )}
                />
                <HasPermissionTo
                  perform={["searchLandingPage"]}
                  permissions={user.permissions.rolePermissions}
                  condition={!this.props.fromNscDealerSearch}
                  render={() =>
                    !this.props.isCrc ? (
                      <>
                        {getLink.call(this, "/search", "GlobalNavBar.search")}
                      </>
                    ) : (
                      <>{getLink.call(this, "/", "GlobalNavBar.search")}</>
                    )
                  }
                />
              </div>
              <div className={styles.flex} />

              <HasPermissionTo
                perform={["dealerSearch"]}
                permissions={user.permissions.rolePermissions}
                condition={this.props.fromDealerSearch}
                render={() => {
                  return (
                    <FieldViewLogout
                      {...this.props}
                      styles={styles}
                      open={this.state.open}
                      handleLogoutDialogOpen={this.handleLogoutDialogOpen}
                      handleLogoutClose={this.handleLogoutClose}
                      handleLogoutDialogClose={this.handleLogoutDialogClose}
                      isFordBrand={IS_FORD_BRAND(this.props.user.brand)}
                    />
                  );
                }}
              />

              {showPoLogout ? (
                <PoUserLogout
                  {...this.props}
                  styles={styles}
                  handleLogoutClick={this.handleLogoutClick}
                  user={user}
                  name={name}
                  anchorEl={this.state.anchorEl}
                  handleLogoutClose={this.handleLogoutClose}
                  handleLogoutDialogOpen={this.handleLogoutDialogOpen}
                  open={this.state.open}
                  handleLogoutDialogClose={this.handleLogoutDialogClose}
                  handleDealerSearch={this.handlePoDealerSearch}
                  handleOrderSearch={this.handlePoOrderSearch}
                  handleNscSearch={this.handlePoNscSearch}
                />
              ) : showNscLogout ? (
                <NscUserLogout
                  {...this.props}
                  styles={styles}
                  handleLogoutClick={this.handleLogoutClick}
                  user={user}
                  name={name}
                  anchorEl={this.state.anchorEl}
                  handleLogoutClose={this.handleLogoutClose}
                  handleLogoutDialogOpen={this.handleLogoutDialogOpen}
                  open={this.state.open}
                  handleLogoutDialogClose={this.handleLogoutDialogClose}
                  handleDealerSearch={this.handleDealerSearch}
                  handleOrderSearch={this.handleOrderSearch}
                />
              ) : (
                <Logout
                  {...this.props}
                  styles={styles}
                  handleLogoutClick={this.handleLogoutClick}
                  user={user}
                  name={name}
                  anchorEl={this.state.anchorEl}
                  handleLogoutClose={this.handleLogoutClose}
                  handleLogoutDialogOpen={this.handleLogoutDialogOpen}
                  open={this.state.open}
                  handleLogoutDialogClose={this.handleLogoutDialogClose}
                />
              )}
            </Grid>
          </Grid>
        </Toolbar>
      </AppBar>
    );
  }
}

const FieldViewLogout = (props) => {
  return (
    <div>
      <div className={props.styles.dealerContainer}>
        <div
          className={`${props.styles.dealerBox} ${props.styles.withPointer}`}
          onClick={props.handleLogoutDialogOpen}
        >
          <span className={props.styles.logoutFontStyle}>
            {props.isFordBrand
              ? props.t("Logout.logoutDealerSearch")
              : props.t("Logout.logoutCap")}
          </span>
        </div>
      </div>
      <LogoutDialogAction {...props} />
    </div>
  );
};
const Logout = (props) => {
  return (
    <div data-testid="logout">
      <div className={props.styles.dealerContainer}>
        <div className={props.styles.dealerBox}>
          <DealerDetails
            user={props.user}
            name={props.name}
            styles={props.styles}
          />
          <div
            className={props.styles.withPointer}
            onClick={props.handleLogoutClick}
          >
            <KeyboardArrowDown
              id="logout-menu"
              className={props.styles.arrow}
            />
          </div>
        </div>
      </div>
      <StyledMenu
        className={props.styles.userSection}
        id="customized-menu"
        disableAutoFocusItem
        anchorEl={props.anchorEl}
        keepMounted
        open={Boolean(props.anchorEl)}
        onClose={props.handleLogoutClose}
      >
        <StyledMenuItem
          onClick={props.handleLogoutDialogOpen}
          to={{ pathname: "/" }}
        >
          <span className={props.styles.logoutTextStyle}>
            {props.t("Logout.logout")}
          </span>
        </StyledMenuItem>
      </StyledMenu>
      <LogoutDialogAction {...props} />
    </div>
  );
};

const NscUserLogout = (props) => {
  return (
    <div data-testid="nscUserLogout">
      <div className={props.styles.dealerContainer}>
        <div className={props.styles.dealerBox}>
          <DealerDetails
            {...props}
            user={props.user}
            name={props.name}
            styles={props.styles}
          />
          <div
            className={props.styles.withPointer}
            onClick={props.handleLogoutClick}
          >
            {!props.anchorEl ? (
              <KeyboardArrowDown
                id="logout-menu-arrowDown"
                className={props.styles.arrow}
              />
            ) : (
              <KeyboardArrowUp
                id="logout-menu-arrowUp"
                className={props.styles.arrow}
              />
            )}
          </div>
        </div>
      </div>
      <StyledMenu
        className={props.styles.userSection}
        id="customized-menu"
        disableAutoFocusItem
        anchorEl={props.anchorEl}
        keepMounted
        open={Boolean(props.anchorEl)}
        onClose={props.handleLogoutClose}
      >
        <StyledMenuItem
          onClick={props.handleOrderSearch}
          to={{ pathname: "/search/orders" }}
        >
          <span className={props.styles.orderSearchIcon} />
          <span
            className={props.styles.logoutFont}
            data-testid="orderSearch-logout-menu"
          >
            {props.t("Logout.orderSearch")}
          </span>
        </StyledMenuItem>
        <StyledMenuItem
          onClick={props.handleDealerSearch}
          to={{ pathname: "/search/dealer" }}
        >
          <span className={props.styles.dealerSearchIcon} />
          <span
            className={props.styles.logoutFont}
            data-testid="dealerSearch-logout-menu"
          >
            {props.t("Logout.dealerSearch")}
          </span>
        </StyledMenuItem>
        <StyledMenuItem
          onClick={props.handleLogoutDialogOpen}
          to={{ pathname: "/" }}
        >
          <span className={props.styles.logoutIcon} />
          <span className={props.styles.logoutFont}>
            {props.t("Logout.logout")}
          </span>
        </StyledMenuItem>
      </StyledMenu>
      <LogoutDialogAction {...props} />
    </div>
  );
};

const PoUserLogout = (props) => {
  return (
    <div data-testid="poUserLogout">
      <div className={props.styles.dealerContainer}>
        <div className={props.styles.dealerBox}>
          <EUPoDetails
            {...props}
            styles={props.styles}
            name={props.user.fullName || props.user.name}
          />
          <div
            className={props.styles.withPointer}
            onClick={props.handleLogoutClick}
          >
            {!props.anchorEl ? (
              <KeyboardArrowDown
                id="logout-menu-arrowDown"
                className={props.styles.arrow}
              />
            ) : (
              <KeyboardArrowUp
                id="logout-menu-arrowUp"
                className={props.styles.arrow}
              />
            )}
          </div>
        </div>
      </div>
      <StyledMenu
        className={props.styles.userSection}
        id="customized-menu"
        disableAutoFocusItem
        anchorEl={props.anchorEl}
        keepMounted
        open={Boolean(props.anchorEl)}
        onClose={props.handleLogoutClose}
      >
        <StyledMenuItem
          onClick={props.handleOrderSearch}
          to={{ pathname: "/search/orders" }}
        >
          <span className={props.styles.orderSearchIcon} />
          <span
            className={props.styles.logoutFont}
            data-testid="orderSearch-logout-menu"
          >
            {props.t("Logout.orderSearch")}
          </span>
        </StyledMenuItem>
        <StyledMenuItem
          onClick={props.handleDealerSearch}
          to={{ pathname: "/search/dealer" }}
        >
          <span className={props.styles.dealerSearchIcon} />
          <span
            className={props.styles.logoutFont}
            data-testid="dealerSearch-logout-menu"
          >
            {props.t("Logout.dealerSearch")}
          </span>
        </StyledMenuItem>

        <StyledMenuItem
          onClick={props.handleNscSearch}
          to={{ pathname: "/search/nsc" }}
        >
          <span className={props.styles.dealerSearchIcon} />
          <span
            className={props.styles.logoutFont}
            data-testid="nscSearch-logout-menu"
          >
            {props.t("Logout.nscSearch")}
          </span>
        </StyledMenuItem>

        <StyledMenuItem
          onClick={props.handleLogoutDialogOpen}
          to={{ pathname: "/" }}
        >
          <span className={props.styles.logoutIcon} />
          <span className={props.styles.logoutFont}>
            {props.t("Logout.logout")}
          </span>
        </StyledMenuItem>
      </StyledMenu>
      <LogoutDialogAction {...props} />
    </div>
  );
};

const LogoutDialogAction = (props) => {
  return (
    <Dialog
      open={props.open}
      onClose={props.handleLogoutDialogClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          <span className={props.styles.logoutConfirmationFont}>
            {props.t("Logout.confirmation")}
          </span>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={props.handleLogoutDialogClose} color="primary">
          {props.t("Logout.decline")}
        </Button>
        <Button
          onClick={invalidateSessionAndRedirect}
          color="primary"
          autoFocus
        >
          {props.t("Logout.confirm")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

const DealerDetails = (props) => {
  return (
    <div>
      <div id="name">
        {props.user.fullName}
        {props.user.userType === "dealer" && props.name}
      </div>

      <div className={props.styles.dealerViewIndicator}>
        {props.fromNscDealerSearch
          ? props.t("GlobalNavBar.dealerView")
          : props.userDetails && props.userDetails.fromPoNscSearch
          ? props.t("GlobalNavBar.nscView")
          : null}
      </div>
    </div>
  );
};
const EUPoDetails = (props) => {
  return (
    <div>
      <div id="name">
        <span>{props.name}</span>
      </div>
      <div className={props.styles.dealerViewIndicator}>
        {props.userDetails && props.userDetails.fromPoNscSearch
          ? props.t("GlobalNavBar.nscView")
          : props.fromNscDealerSearch
          ? props.t("GlobalNavBar.dealerView")
          : ""}
      </div>
    </div>
  );
};
export default withTranslation("emp")(GlobalNavBar);
